export { useAuthGuard } from "./useAuthGuard";
export { useAuthConfig, type AuthConfig } from "./useAuthConfig";
